import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')



// Users
const login = () => import('@/views/Login')
const stone = () => import('@/views/stone')
const Signup = () => import('@/views/Signup')
const signupNote= () => import('@/views/signupNote')
const terms = () =>import('@/views/terms')
Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',

      name: 'Home',
      component:DefaultContainer,

      children: [
        {
          path: '',
          name: 'Search',
          component: Dashboard
        },
        {
          path: 'login',
          name: 'Login',
          component: login
        },
        {
          path: 'terms',
          name: 'Terms',
          component: terms
        },
        {
          path: 'stone/:id',
          name: 'Stone',
          component: stone
        },
        {
          path: 'signup',
          name: 'Signup',
          component: Signup
        },
        {
          path: 'signup-note',
          name: 'Signup Pending',
          component: signupNote
        },






      ]
    },

  ]
})
